import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import api from "@/lib/api";
import { Field } from "@/components/Common";
import { BoldTextarea } from "@/components/BoldTextarea";

export const TermsPicker = ({ terms, warranty, onChange, testPrefix = "terms" }) => {
  const [tpls, setTpls] = useState([]);
  const [picked, setPicked] = useState("");
  useEffect(() => { api.get("/terms-templates").then((r) => setTpls(r.data)); }, []);

  const apply = (id) => {
    setPicked(id);
    if (id === "__default") return api.get("/settings").then((r) => onChange({ terms: r.data.terms || "", warranty_terms: r.data.warranty_terms || "" }));
    const t = tpls.find((x) => x.id === id);
    if (t) onChange({ terms: t.terms, warranty_terms: t.warranty_terms });
  };

  return (
    <div className="space-y-3" data-testid={`${testPrefix}-picker`}>
      <div className="flex flex-wrap items-center gap-2 rounded-lg border border-blue-100 bg-blue-50/60 px-3 py-2">
        <FileText className="h-4 w-4 text-blue-800" />
        <span className="text-sm font-semibold text-blue-900">Template TOP</span>
        <select className="h-9 min-w-[240px] rounded-md border border-input bg-white px-2 text-sm" value={picked} onChange={(e) => apply(e.target.value)} data-testid={`${testPrefix}-template-select`}>
          <option value="">— Pilih template —</option>
          <option value="__default">Default (Pengaturan)</option>
          {tpls.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <span className="text-xs text-slate-500">Isi di bawah tetap bisa diedit setelah dipilih.</span>
      </div>
      <Field label="Syarat & Kondisi Umum (TOP)"><BoldTextarea rows={8} className="text-xs" value={terms} onChange={(v) => onChange({ terms: v })} testId={`${testPrefix}-terms-input`} /></Field>
      <Field label="Ketentuan Umum Garansi"><BoldTextarea rows={4} className="text-xs" value={warranty} onChange={(v) => onChange({ warranty_terms: v })} testId={`${testPrefix}-warranty-input`} /></Field>
    </div>
  );
};
